import { SupportedLanguages } from './types'
import { registerLocale, getNames } from 'i18n-iso-countries'
import * as enLocale from 'i18n-iso-countries/langs/en.json'
import * as svLocale from 'i18n-iso-countries/langs/sv.json'
import * as elLocale from 'i18n-iso-countries/langs/el.json'
import { useCallback, useMemo } from 'react'

export const useIsoCountries = () => {
  registerLocale(svLocale)
  registerLocale(elLocale)
  registerLocale(enLocale)

  const getCountries = useCallback((lang: SupportedLanguages) => {
    const countries = getNames(lang, { select: 'official' })
    return Object.entries(countries).map(([code, name]) => ({ code: code?.toLowerCase(), name }))
  }, [])

  const memo = useMemo(
    () => ({
      getCountries,
    }),
    [],
  )

  return memo
}
